import { StoreStockData } from 'common/components/stocks-in-stores/types';
import { transliterate } from 'utils';

export const createStoreLink = (regionCode: string, stocks: StoreStockData[]) => {
  const linkRegionName = getLinkRegionName(regionCode);
  const storeName = stocks[0]?.storeName;
  return storeName ? `/shop/${linkRegionName}${transliterate(storeName)}/` : null;
};

const getLinkRegionName = (regionCode: string) => {
  switch (regionCode) {
    case '':
      return 'moskva-';
    case 'spb':
      return 'sankt-peterburg-';
    default:
      return '';
  }
};
